"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._GetVoucherServerErrorFallback = exports._GetTopfitVoucherFallback = exports._TopfitVoucherFallbacks = void 0;
var _TopfitTenantKey = 'topfit-fitness';
var _VoucherServerErrorCode = 'SERVER_ERROR';
exports._TopfitVoucherFallbacks = {
    '12WEEKS': {
        voucherSuccessMessage: 'Voucher redeemed successfully, gain 12 weeks for free',
    },
    '16WEEKS': {
        voucherSuccessMessage: 'Voucher redeemed successfully, gain 16 weeks for free',
    },
    '8WEEKS': {
        voucherSuccessMessage: 'Voucher redeemed successfully, gain 8 weeks for free',
    },
};
var _GetTopfitVoucherFallback = function (tenantKey, voucherCode, status) {
    if (tenantKey !== _TopfitTenantKey || status !== 500)
        return undefined;
    return exports._TopfitVoucherFallbacks[voucherCode];
};
exports._GetTopfitVoucherFallback = _GetTopfitVoucherFallback;
var _GetVoucherServerErrorFallback = function (status, errorCodes) {
    if (status !== 500 || !(errorCodes === null || errorCodes === void 0 ? void 0 : errorCodes.includes(_VoucherServerErrorCode)))
        return undefined;
    return {
        voucherSuccessMessage: 'Voucher code used',
    };
};
exports._GetVoucherServerErrorFallback = _GetVoucherServerErrorFallback;
